import { render, staticRenderFns } from "./DashboardToolbar.vue?vue&type=template&id=1254863a"
import script from "./DashboardToolbar.vue?vue&type=script&lang=js"
export * from "./DashboardToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports